// src/components/preview-menu/preview-menu.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    size\n    text\n    weight\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment CommunicationCenterEmptyStateFragment on CommunicationCenterEmptyState {\n    __typename\n    title {\n      ...EGDSStylizedTextFragment\n    }\n    body {\n      ...EGDSStylizedTextFragment\n    }\n    image {\n      url\n      description\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n    emptyStateType\n    actions {\n      button {\n        ... on UIPrimaryButton {\n          __typename\n          primary\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n      }\n      action {\n        ... on UILinkAction {\n          resource {\n            value\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IconFragment on Icon {\n    title\n    description\n    id\n    token\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    graphic {\n      ...IconFragment\n    }\n    text\n  }\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment NotificationsDeleteActionFormFragment on CommunicationCenterNotificationForm {\n    __typename\n    title {\n      ...EGDSStylizedTextFragment\n    }\n    sections {\n      title {\n        ...EGDSStylizedTextFragment\n      }\n      fields {\n        button {\n          ... on UITertiaryButton {\n            __typename\n            primary\n          }\n          ... on UIPrimaryButton {\n            __typename\n            primary\n          }\n        }\n        action {\n          ... on UILinkAction {\n            resource {\n              value\n            }\n          }\n        }\n      }\n    }\n    feedbackMessages {\n      name\n      title {\n        ...EGDSStylizedTextFragment\n      }\n      displayType\n      level\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment NotificationsLinkFragment on EGDSStandardLink {\n    __typename\n    text\n    size\n    action {\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment NotificationsItemFragment on CommunicationCenterNotificationCard {\n    __typename\n    cardId\n    title {\n      ...EGDSStylizedTextFragment\n    }\n    body {\n      ...EGDSStylizedTextFragment\n    }\n    type\n    icon {\n      ...IconFragment\n    }\n    links {\n      ...NotificationsLinkFragment\n    }\n    impressionAnalytics {\n      event\n      referrerId\n      linkName\n    }\n    revealActions {\n      referrerId\n      linkName\n      eventType\n    }\n    userActions {\n      __typename\n      icon {\n        id\n        description\n      }\n      type\n      text {\n        size\n        text\n        weight\n      }\n      revealActions {\n        referrerId\n        linkName\n        eventType\n      }\n    }\n    timeStamp {\n      ...EGDSStylizedTextFragment\n    }\n    state\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  mutation UpdateNotificationsInMenuMutation(\n    $contextInput: ContextInput!\n    $notificationIds: [String!]!\n    $state: CommunicationCenterNotificationState!\n  ) {\n    updateNotificationsState(context: $contextInput, notificationIds: $notificationIds, state: $state) {\n      notificationId\n      operationStatus\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  query CommunicationCenterPreviewQuery($context: ContextInput!, $optionalContext: OptionalContextInput) {\n    communicationCenterPreview(context: $context, optionalContext: $optionalContext) {\n      label {\n        ...EGDSStylizedTextFragment\n      }\n      notifications {\n        heading {\n          ...EGDSStylizedTextFragment\n        }\n        unseen\n        notifications {\n          ...NotificationsItemFragment\n        }\n        emptyState {\n          ...CommunicationCenterEmptyStateFragment\n        }\n        deleteActionForm {\n          ...NotificationsDeleteActionFormFragment\n        }\n        impressionAnalytics {\n          event\n          referrerId\n          linkName\n        }\n        clickToActionButton {\n          button {\n            ... on UIPrimaryButton {\n              primary\n              analytics {\n                linkName\n                referrerId\n              }\n            }\n          }\n          action {\n            ... on UILinkAction {\n              resource {\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  query CommunicationCenterPreviewMenuQuery($context: ContextInput!) {\n    communicationCenterEntryPoint(context: $context) {\n      __typename\n      icon {\n        id\n        token\n        description\n      }\n      label\n      notificationUnseenCount\n      messageUnseenCount\n      defaultTab\n      clickAnalytics {\n        linkName\n        referrerId\n        eventType\n      }\n      impressionAnalytics {\n        event\n        referrerId\n        linkName\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  query PreviewMenuGlobalHeaderQuery(\n    $context: ContextInput!\n    $viewSize: HeaderViewSize\n    $lineOfBusiness: GlobalNavigationLineOfBusiness\n    $layout: HeaderLayout\n  ) {\n    globalHeader(context: $context, viewSize: $viewSize, lineOfBusiness: $lineOfBusiness, layout: $layout) {\n      redDotState @client\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
import React13 from "react";
import { gql as gql10, useApolloClient, useQuery } from "@apollo/client";
import { useBexApi as useBexApi5 } from "@shared-ui/bex-api-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/preview-menu/preview-menu-content-wrapper.tsx
import React11 from "react";
import { gql as gql9, useLazyQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker4, useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/comm-center-empty-state/comm-center-empty-state.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize, UitkFloatingFullWidthButton } from "uitk-react-button";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
// ../internal/src/components/utils/redirect-gss-url.tsx
var redirectGSSUrl = function(redirectPath) {
    var queryParams = "";
    if (typeof window !== "undefined" && window.location !== null) {
        var locationPathname = window.location.pathname ? window.location.pathname : "";
        var locationSearch = window.location.search ? window.location.search : "";
        var locationHash = window.location.hash ? window.location.hash : "";
        var returnUrl = locationPathname.concat(locationSearch, locationHash);
        queryParams = "?&uurl=".concat(encodeURIComponent("e3id=redr&rurl=".concat(returnUrl)));
    }
    return redirectPath + queryParams;
};
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/utils/uitk-text-utils.ts
import { UitkFigureAspectRatioType } from "uitk-react-images";
var _obj;
var UitkTextWeightMap = (_obj = {}, _defineProperty(_obj, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj, "REGULAR" /* REGULAR */ , "regular"), _obj);
var TextSizeToUitkTextSizeMap = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var _obj1;
var AspectRatioMap = (_obj1 = {}, _defineProperty(_obj1, "ONE_ONE" /* ONE_ONE */ , UitkFigureAspectRatioType.R1_1), _defineProperty(_obj1, "FOUR_THREE" /* FOUR_THREE */ , UitkFigureAspectRatioType.R4_3), _defineProperty(_obj1, "SIXTEEN_NINE" /* SIXTEEN_NINE */ , UitkFigureAspectRatioType.R16_9), _defineProperty(_obj1, "THREE_TWO" /* THREE_TWO */ , UitkFigureAspectRatioType.R3_2), _defineProperty(_obj1, "THREE_FOUR" /* THREE_FOUR */ , UitkFigureAspectRatioType.R3_4), _defineProperty(_obj1, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */ , UitkFigureAspectRatioType.R21_9), _defineProperty(_obj1, "FOUR_ONE" /* FOUR_ONE */ , UitkFigureAspectRatioType.R4_1), _obj1);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment = gql(_templateObject());
function getWeight(weightOverride, weight) {
    if (weightOverride) {
        return weightOverride;
    }
    if (weight) {
        return UitkTextWeightMap[weight];
    }
    return void 0;
}
var EGDSStylizedText = function(param) {
    var spacing = param.spacing, overflow = param.overflow, weightOverride = param.weightOverride, align = param.align, theme = param.theme, isStriked = param.isStriked, data = param.data;
    var size = data.size, text = data.text, weight = data.weight;
    return /* @__PURE__ */ React.createElement(UitkText, {
        align: align,
        overflow: overflow,
        size: size ? TextSizeToUitkTextSizeMap[size] : void 0,
        spacing: spacing,
        weight: getWeight(weightOverride, weight),
        inline: isStriked ? "s" : void 0,
        theme: theme
    }, text);
};
EGDSStylizedText.fragment = fragment;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/comm-center-empty-state/comm-center-empty-state.tsx
var fragment2 = gql2(_templateObject1(), EGDSStylizedText.fragment);
var CommunicationCenterEmptyState = function(param) {
    var data = param.data;
    var _actions_, _actions__action;
    var title = data.title, body = data.body, image = data.image, actions = data.actions, impressionAnalytics = data.impressionAnalytics, emptyStateType = data.emptyStateType;
    var bodyItem = body === null || body === void 0 ? void 0 : body[0];
    var actionButton = actions === null || actions === void 0 ? void 0 : actions[0].button;
    var clickAnalytics = actionButton === null || actionButton === void 0 ? void 0 : actionButton.analytics;
    var referrerId = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId;
    var linkName = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName;
    var impressionReferrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId;
    var impressionLinkName = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || "";
    var analyticsTracker = useClickTracker();
    var _React2_useState = _slicedToArray(React2.useState(actions === null || actions === void 0 ? void 0 : (_actions_ = actions[0]) === null || _actions_ === void 0 ? void 0 : (_actions__action = _actions_.action) === null || _actions__action === void 0 ? void 0 : _actions__action.resource.value), 2), redirectPath = _React2_useState[0], setRedirectPath = _React2_useState[1];
    var onEmptyStateButtonClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
    };
    React2.useEffect(function() {
        if (emptyStateType === "SIGN_IN" /* SIGN_IN */ ) {
            var _actions_, _actions__action;
            setRedirectPath(redirectGSSUrl(actions === null || actions === void 0 ? void 0 : (_actions_ = actions[0]) === null || _actions_ === void 0 ? void 0 : (_actions__action = _actions_.action) === null || _actions__action === void 0 ? void 0 : _actions__action.resource.value));
        }
    }, [
        actions,
        emptyStateType
    ]);
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, impressionReferrerId && /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, /* @__PURE__ */ React2.createElement(UitkLayoutFlex, {
        alignItems: "center",
        justifyContent: "center",
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React2.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            inlinestart: "four",
            inlineend: "four",
            blockend: "sixteen"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(UitkLayoutFlexItem, {
        alignSelf: "center",
        grow: 1,
        maxWidth: 300
    }, /* @__PURE__ */ React2.createElement("section", null, /* @__PURE__ */ React2.createElement(UitkFigure, {
        imageFit: "contain"
    }, /* @__PURE__ */ React2.createElement(UitkImage, {
        alt: image === null || image === void 0 ? void 0 : image.description,
        src: image === null || image === void 0 ? void 0 : image.url
    })), /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "four",
            blockend: "four"
        }
    }, /* @__PURE__ */ React2.createElement(UitkHeading, {
        align: "center",
        tag: "h1",
        size: 5
    }, title === null || title === void 0 ? void 0 : title.text)), /* @__PURE__ */ React2.createElement(UitkSpacing, {
        padding: {
            blockstart: "four",
            blockend: "six"
        }
    }, /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement(EGDSStylizedText, {
        data: bodyItem,
        align: "center"
    }))), /* @__PURE__ */ React2.createElement(UitkFloatingFullWidthButton, {
        tag: "a",
        href: redirectPath,
        size: UitkButtonSize.LARGE,
        onClick: onEmptyStateButtonClick
    }, actionButton === null || actionButton === void 0 ? void 0 : actionButton.primary)))))))));
};
CommunicationCenterEmptyState.fragment = fragment2;
CommunicationCenterEmptyState.displayName = "CommunicationCenterEmptyState";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkText as UitkText2 } from "uitk-react-text";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var fragment3 = gql3(_templateObject2());
var Icon = function(param) {
    var data = param.data, isIconOnly = param.isIconOnly, onClick = param.onClick;
    var id = data.id, title = data.title, description = data.description;
    var iconBaseProps = {
        name: id,
        id: id,
        title: title || id,
        description: description || id
    };
    if (isIconOnly) {
        return /* @__PURE__ */ React3.createElement(UitkIcon, _objectSpreadProps(_objectSpread({}, iconBaseProps), {
            size: UitkIconSize.MEDIUM
        }));
    }
    var handleClick = function() {
        if (onClick) {
            onClick();
        }
    };
    return /* @__PURE__ */ React3.createElement(UitkTertiaryButton, {
        tag: "a",
        href: "#",
        onClick: handleClick
    }, /* @__PURE__ */ React3.createElement(UitkIcon, _objectSpread({}, iconBaseProps)));
};
Icon.fragment = fragment3;
Icon.displayName = "Icon";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
var fragment4 = gql4(_templateObject3(), Icon.fragment);
var EGDSGraphicText = function(param) {
    var data = param.data;
    var graphic = data.graphic, text = data.text;
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, graphic.__typename === "Icon" && /* @__PURE__ */ React4.createElement(UitkIcon2, {
        name: graphic.id,
        description: graphic.description
    }), /* @__PURE__ */ React4.createElement(UitkText2, null, text));
};
EGDSGraphicText.fragment = fragment4;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/notifications-delete-action-form/notifications-delete-action-form.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkHeading as UitkHeading2, UitkParagraph } from "uitk-react-text";
var fragment5 = gql5(_templateObject4(), EGDSStylizedText.fragment);
var NotificationsDeleteActionForm = function(param) {
    var data = param.data, notification = param.notification, handleCancelClick = param.handleCancelClick, handleConfirmClick = param.handleConfirmClick;
    var _data_title, _data_sections__title, _data_sections;
    var confirmButton = data === null || data === void 0 ? void 0 : data.sections[0].fields[0].button;
    var confirmButtonLabel = confirmButton.primary || "";
    var cancelButton = data === null || data === void 0 ? void 0 : data.sections[0].fields[1].button;
    var cancelButtonLabel = cancelButton.primary || "";
    return /* @__PURE__ */ React5.createElement(UitkDialog, {
        dialogShow: true,
        returnFocusOnClose: true,
        autoFocus: true
    }, /* @__PURE__ */ React5.createElement(UitkDialogContent, null, /* @__PURE__ */ React5.createElement(UitkHeading2, {
        tag: "h1",
        size: 5,
        key: "dialogHeading"
    }, data === null || data === void 0 ? void 0 : (_data_title = data.title) === null || _data_title === void 0 ? void 0 : _data_title.text), /* @__PURE__ */ React5.createElement(UitkParagraph, {
        key: "dialogParagraph",
        size: 2
    }, (_data_sections__title = data === null || data === void 0 ? void 0 : (_data_sections = data.sections) === null || _data_sections === void 0 ? void 0 : _data_sections[0].title) === null || _data_sections__title === void 0 ? void 0 : _data_sections__title.text), /* @__PURE__ */ React5.createElement(UitkDialogFooter, {
        key: "UitkDialogFooter",
        stacked: true,
        buttonOne: {
            onClick: function() {
                handleConfirmClick(notification);
            },
            text: confirmButtonLabel,
            type: "primary"
        },
        buttonTwo: {
            onClick: handleCancelClick,
            text: cancelButtonLabel,
            type: "tertiary"
        }
    })));
};
NotificationsDeleteActionForm.fragment = fragment5;
NotificationsDeleteActionForm.displayName = "NotificationsDeleteActionForm";
// ../internal/src/components/notifications-item/notifications-item.tsx
import React9 from "react";
import { gql as gql7 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker2, useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkDotNotificationBadge } from "uitk-react-badge";
import { UitkCardContentSection as UitkCardContentSection2, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
// ../internal/src/components/notifications-link/notifications-link.tsx
import React8 from "react";
import { gql as gql6 } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/notifications-list-provider/notifications-list-provider.tsx
import React6, { createContext, useReducer } from "react";
// ../internal/src/components/notifications-list-provider/notifications-list-reducer.ts
var reducer = function(state, action) {
    var initialNotificationsListState = {
        notificationsList: [],
        unseenCount: 0
    };
    var doesPayloadContain = function(notification) {
        var _action_payload, _action_payload_notificationsList;
        var foundNotification = (_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : (_action_payload_notificationsList = _action_payload.notificationsList) === null || _action_payload_notificationsList === void 0 ? void 0 : _action_payload_notificationsList.find(function(payloadNotification) {
            return payloadNotification.cardId === notification.cardId;
        });
        return foundNotification !== null && foundNotification !== void 0;
    };
    var setNotificationState = function(notificationState) {
        return state.notificationsList.map(function(notification) {
            if (doesPayloadContain(notification)) {
                return _objectSpreadProps(_objectSpread({}, notification), {
                    state: notificationState
                });
            }
            return notification;
        });
    };
    switch(action.action){
        case 0 /* MARK_AS_UNREAD */ :
            return _objectSpreadProps(_objectSpread({}, state), {
                notificationsList: setNotificationState("SEEN" /* SEEN */ ),
                unseenCount: 0
            });
        case 1 /* MARK_AS_READ */ :
            return _objectSpreadProps(_objectSpread({}, state), {
                notificationsList: setNotificationState("READ" /* READ */ ),
                unseenCount: 0
            });
        case 2 /* DELETE */ :
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    notificationsList: state.notificationsList.filter(function(notification) {
                        return !doesPayloadContain(notification);
                    }),
                    unseenCount: 0
                });
            }
        default:
            return initialNotificationsListState;
    }
};
// ../internal/src/components/notifications-list-provider/notifications-list-provider.tsx
var DEFAULT = {
    notificationsList: [],
    unseenCount: 0
};
var NotificationsListContext = createContext({
    state: DEFAULT
});
var NotificationsListProvider = function(props) {
    var notificationsList = props.notificationsList, unseenCount = props.unseenCount, children = props.children;
    var _useReducer = _slicedToArray(useReducer(reducer, _objectSpreadProps(_objectSpread({}, DEFAULT), {
        notificationsList: notificationsList,
        unseenCount: unseenCount
    })), 2), state = _useReducer[0], dispatch = _useReducer[1];
    return /* @__PURE__ */ React6.createElement(NotificationsListContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        }
    }, children || null);
};
var useNotificationsList = function() {
    return React6.useContext(NotificationsListContext);
};
// ../internal/src/components/notifications-update-provider/notifications-update-provider.tsx
import React7, { createContext as createContext2, useContext } from "react";
import { useMutation } from "@apollo/client";
var DEFAULT2 = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    mutation: function() {},
    error: void 0,
    loading: false
};
var NotificationsUpdateContext = createContext2(DEFAULT2);
var NotificationsUpdateProvider = function(props) {
    var mutationFunction = props.mutationFunction, children = props.children;
    var _useMutation = _slicedToArray(useMutation(mutationFunction), 2), mutation = _useMutation[0], _useMutation_ = _useMutation[1], error = _useMutation_.error, loading = _useMutation_.loading;
    return /* @__PURE__ */ React7.createElement(NotificationsUpdateContext.Provider, {
        value: {
            mutation: mutation,
            error: error,
            loading: loading
        }
    }, children || null);
};
var useUpdateNotificationsMutationState = function() {
    return useContext(NotificationsUpdateContext);
};
// ../internal/src/components/notifications-link/notifications-link.tsx
var fragment6 = gql6(_templateObject5());
var NotificationsLink = function(param) {
    var notification = param.notification, data = param.data, children = param.children;
    var _data_action, _data_action_resource, _data_action1, _data_action_resource1, _data_action2;
    var deeplink = (data === null || data === void 0 ? void 0 : (_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_resource = _data_action.resource) === null || _data_action_resource === void 0 ? void 0 : _data_action_resource.value) ? data === null || data === void 0 ? void 0 : (_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_resource1 = _data_action1.resource) === null || _data_action_resource1 === void 0 ? void 0 : _data_action_resource1.value : "#";
    var clickAnalytics = data === null || data === void 0 ? void 0 : (_data_action2 = data.action) === null || _data_action2 === void 0 ? void 0 : _data_action2.analytics;
    var referrerId = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId;
    var linkName = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName;
    var analyticsTracker = useClickTracker2();
    var context = useBexApi().context;
    var mutation = useUpdateNotificationsMutationState().mutation;
    var dispatch = useNotificationsList().dispatch;
    var notificationId = notification === null || notification === void 0 ? void 0 : notification.cardId;
    var state = notification === null || notification === void 0 ? void 0 : notification.state;
    var onLinkClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
        if (state === "SEEN" /* SEEN */ ) {
            dispatch({
                action: 1 /* MARK_AS_READ */ ,
                payload: {
                    notificationsList: [
                        notification
                    ]
                }
            });
            mutation({
                variables: {
                    contextInput: context,
                    notificationIds: [
                        notificationId
                    ],
                    state: "READ" /* READ */ 
                }
            });
        }
    };
    return /* @__PURE__ */ React8.createElement("a", {
        href: deeplink,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onLinkClick
    }, children);
};
NotificationsLink.fragment = fragment6;
NotificationsLink.displayName = "NotificationsLink";
// ../internal/src/components/notifications-item/notifications-item.tsx
var fragment7 = gql7(_templateObject6(), Icon.fragment, EGDSStylizedText.fragment, NotificationsLink.fragment);
var NotificationsItem = function(param) {
    var data = param.data, children = param.children;
    var _data_impressionAnalytics, _data_links__action, _data_links, _data_links1, _data_links2, _data_links3, _data_links4, _data_links__action1, _data_links5, _data_links__action_resource, _data_links__action2, _data_links6, _data_links__action_resource1, _data_title, _data_title1, _data_body, _data_body_, _data_body1, _data_timeStamp;
    var impressionAnalytics = data === null || data === void 0 ? void 0 : (_data_impressionAnalytics = data.impressionAnalytics) === null || _data_impressionAnalytics === void 0 ? void 0 : _data_impressionAnalytics[0];
    var impressionReferrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId;
    var impressionLinkName = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || "";
    var clickAnalytics = (_data_links__action = data === null || data === void 0 ? void 0 : (_data_links = data.links) === null || _data_links === void 0 ? void 0 : _data_links[0].action) === null || _data_links__action === void 0 ? void 0 : _data_links__action.analytics;
    var referrerId = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId;
    var linkName = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName;
    var cardId = data === null || data === void 0 ? void 0 : data.cardId;
    var state = data === null || data === void 0 ? void 0 : data.state;
    var analyticsTracker = useClickTracker3();
    var context = useBexApi2().context;
    var mutation = useUpdateNotificationsMutationState().mutation;
    var dispatch = useNotificationsList().dispatch;
    var onLinkClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
        if (state === "SEEN" /* SEEN */ ) {
            dispatch({
                action: 1 /* MARK_AS_READ */ ,
                payload: {
                    notificationsList: [
                        data
                    ]
                }
            });
            mutation({
                variables: {
                    contextInput: context,
                    notificationIds: [
                        cardId
                    ],
                    state: "READ" /* READ */ 
                }
            });
        }
    };
    return /* @__PURE__ */ React9.createElement(React9.Fragment, null, impressionReferrerId && /* @__PURE__ */ React9.createElement(IntersectionTracker2, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, /* @__PURE__ */ React9.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem2, {
        alignSelf: "start",
        grow: 0
    }, ((_data_links1 = data.links) === null || _data_links1 === void 0 ? void 0 : _data_links1[0]) && /* @__PURE__ */ React9.createElement(NotificationsLink, {
        notification: data,
        data: (_data_links2 = data.links) === null || _data_links2 === void 0 ? void 0 : _data_links2[0]
    }, /* @__PURE__ */ React9.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, /* @__PURE__ */ React9.createElement(UitkSpacing2, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React9.createElement(UitkDotNotificationBadge, {
        visible: data.state !== "READ" /* READ */ 
    }))))), /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem2, {
        alignSelf: "start",
        grow: 0
    }, ((_data_links3 = data.links) === null || _data_links3 === void 0 ? void 0 : _data_links3[0]) && /* @__PURE__ */ React9.createElement(NotificationsLink, {
        notification: data,
        data: (_data_links4 = data.links) === null || _data_links4 === void 0 ? void 0 : _data_links4[0]
    }, /* @__PURE__ */ React9.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, data.icon && /* @__PURE__ */ React9.createElement(Icon, {
        data: data.icon,
        isIconOnly: true
    })))), /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem2, {
        grow: 1
    }, /* @__PURE__ */ React9.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlinestart"
        ]
    }, /* @__PURE__ */ React9.createElement(UitkCardLink, null, /* @__PURE__ */ React9.createElement("a", {
        href: ((_data_links__action1 = (_data_links5 = data.links) === null || _data_links5 === void 0 ? void 0 : _data_links5[0].action) === null || _data_links__action1 === void 0 ? void 0 : (_data_links__action_resource = _data_links__action1.resource) === null || _data_links__action_resource === void 0 ? void 0 : _data_links__action_resource.value) ? (_data_links__action2 = (_data_links6 = data.links) === null || _data_links6 === void 0 ? void 0 : _data_links6[0].action) === null || _data_links__action2 === void 0 ? void 0 : (_data_links__action_resource1 = _data_links__action2.resource) === null || _data_links__action_resource1 === void 0 ? void 0 : _data_links__action_resource1.value : "#",
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onLinkClick
    }, (_data_title = data.title) === null || _data_title === void 0 ? void 0 : _data_title.text)), ((_data_title1 = data.title) === null || _data_title1 === void 0 ? void 0 : _data_title1.text) && /* @__PURE__ */ React9.createElement(UitkHeading3, {
        tag: "h2",
        size: 5
    }, data.title.text), ((_data_body = data.body) === null || _data_body === void 0 ? void 0 : (_data_body_ = _data_body[0]) === null || _data_body_ === void 0 ? void 0 : _data_body_.text) && /* @__PURE__ */ React9.createElement(UitkSpacing2, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(EGDSStylizedText, {
        data: (_data_body1 = data.body) === null || _data_body1 === void 0 ? void 0 : _data_body1[0],
        overflow: "truncate-3-lines",
        weightOverride: data.state === "READ" /* READ */  ? "regular" : "bold"
    }))), ((_data_timeStamp = data.timeStamp) === null || _data_timeStamp === void 0 ? void 0 : _data_timeStamp.text) && /* @__PURE__ */ React9.createElement(UitkSpacing2, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(EGDSStylizedText, {
        data: data.timeStamp,
        spacing: "two"
    }))))), /* @__PURE__ */ React9.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React9.createElement(UitkCardContentSection2, {
        padded: [
            "blockstart",
            "blockend",
            "inlineend"
        ]
    }, children)))));
};
NotificationsItem.fragment = fragment7;
NotificationsItem.displayName = "NotificationsItem";
// src/components/preview-menu/preview-menu-content-wrapper.tsx
import { UitkFloatingDotNotificationBadge } from "uitk-react-badge";
import { UitkButtonSize as UitkButtonSize2, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkLoader } from "uitk-react-loader";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
// src/components/preview-menu/preview-menu-content.tsx
import React10 from "react";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
// src/mutation/update-notification-in-menu-mutation.ts
import { gql as gql8 } from "@apollo/client";
var __UpdateNotificationsInMenuMutation = gql8(_templateObject7());
// src/components/preview-menu/preview-menu-content.tsx
var CommunicationCenterPreviewMenuContent = function(props) {
    var _impressionAnalytics_, _impressionAnalytics_1, _impressionAnalytics_2, _impressionAnalytics_3, _state_notificationsList;
    var heading = props.heading, emptyState = props.emptyState, clickToActionButton = props.clickToActionButton, impressionAnalytics = props.impressionAnalytics;
    var context = useBexApi3().context;
    var analyticsTracker = useClickTracker4();
    var impressionReferrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : (_impressionAnalytics_ = impressionAnalytics[0]) === null || _impressionAnalytics_ === void 0 ? void 0 : _impressionAnalytics_.referrerId;
    var impressionLinkName = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : (_impressionAnalytics_1 = impressionAnalytics[0]) === null || _impressionAnalytics_1 === void 0 ? void 0 : _impressionAnalytics_1.linkName) || "";
    var buttonImpressionReferrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : (_impressionAnalytics_2 = impressionAnalytics[1]) === null || _impressionAnalytics_2 === void 0 ? void 0 : _impressionAnalytics_2.referrerId;
    var buttonImpressionLinkName = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : (_impressionAnalytics_3 = impressionAnalytics[1]) === null || _impressionAnalytics_3 === void 0 ? void 0 : _impressionAnalytics_3.linkName) || "";
    var actionButton = clickToActionButton === null || clickToActionButton === void 0 ? void 0 : clickToActionButton.button;
    var clickAnalytics = actionButton === null || actionButton === void 0 ? void 0 : actionButton.analytics;
    var referrerId = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId;
    var linkName = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName;
    var state = useNotificationsList().state;
    var mutation = useUpdateNotificationsMutationState().mutation;
    var getNotificationIds = function(listOfNotifications) {
        return (listOfNotifications === null || listOfNotifications === void 0 ? void 0 : listOfNotifications.map(function(notification) {
            return notification.cardId || "";
        }).filter(function(notificationId) {
            return notificationId !== "";
        })) || [];
    };
    var onClickToActionButtonClick = function() {
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName);
        }
    };
    React10.useEffect(function() {
        var _state_notificationsList;
        var unseenNotifications = ((_state_notificationsList = state.notificationsList) === null || _state_notificationsList === void 0 ? void 0 : _state_notificationsList.filter(function(notification) {
            return notification.state === "UNSEEN" /* UNSEEN */ ;
        })) || [];
        var notificationIds = getNotificationIds(unseenNotifications);
        if (unseenNotifications && unseenNotifications.length > 0) {
            mutation({
                variables: {
                    contextInput: context,
                    notificationIds: notificationIds,
                    state: "SEEN" /* SEEN */ 
                }
            });
        }
    }, [
        state.notificationsList,
        context,
        mutation
    ]);
    if (state.notificationsList.length === 0) {
        return /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(UitkCardContentSection3, {
            padded: true,
            border: "bottom"
        }, heading && /* @__PURE__ */ React10.createElement(UitkHeading4, {
            size: 5,
            tag: "h1"
        }, heading === null || heading === void 0 ? void 0 : heading.text)), /* @__PURE__ */ React10.createElement(UitkSpacing3, {
            padding: {
                blockstart: "twelve"
            }
        }, /* @__PURE__ */ React10.createElement("section", null, emptyState && /* @__PURE__ */ React10.createElement(CommunicationCenterEmptyState, {
            data: emptyState
        }))));
    }
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, impressionReferrerId && /* @__PURE__ */ React10.createElement(IntersectionTracker3, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, /* @__PURE__ */ React10.createElement(UitkCardContentSection3, {
        padded: true,
        border: "bottom"
    }, heading && /* @__PURE__ */ React10.createElement(UitkHeading4, {
        size: 5,
        tag: "h1"
    }, heading === null || heading === void 0 ? void 0 : heading.text)), /* @__PURE__ */ React10.createElement("section", null, (_state_notificationsList = state.notificationsList) === null || _state_notificationsList === void 0 ? void 0 : _state_notificationsList.map(function(notification, index) {
        return /* @__PURE__ */ React10.createElement("div", {
            key: "notifications-cell-".concat(index),
            "data-stid": "notifications-cell"
        }, /* @__PURE__ */ React10.createElement(UitkSpacing3, {
            padding: {
                block: "half",
                inlinestart: "one",
                inlineend: "half"
            }
        }, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(NotificationsItem, {
            data: notification
        }))));
    })), clickToActionButton && actionButton && actionButton.primary && /* @__PURE__ */ React10.createElement(React10.Fragment, null, buttonImpressionReferrerId && /* @__PURE__ */ React10.createElement(IntersectionTracker3, {
        referrerId: buttonImpressionReferrerId,
        linkName: buttonImpressionLinkName
    }, /* @__PURE__ */ React10.createElement(UitkLayoutPosition, {
        display: "block",
        position: {
            bottom: "zero"
        },
        type: "absolute",
        style: {
            width: "100%"
        }
    }, /* @__PURE__ */ React10.createElement(UitkCardContentSection3, {
        padded: true,
        border: "top"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlex3, {
        justifyContent: "center"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React10.createElement(UitkPrimaryButton, {
        tag: "a",
        href: "/inbox/notifications",
        onClick: onClickToActionButtonClick
    }, actionButton.primary)))))))));
};
CommunicationCenterPreviewMenuContent.displayName = "CommunicationCenterPreviewMenuContent";
var CommunicationCenterPreviewMenuContentWithContext = function(props) {
    var data = props.data;
    var notificationsObject = data.notifications;
    var heading = notificationsObject === null || notificationsObject === void 0 ? void 0 : notificationsObject.heading;
    var emptyState = notificationsObject === null || notificationsObject === void 0 ? void 0 : notificationsObject.emptyState;
    var clickToActionButton = notificationsObject === null || notificationsObject === void 0 ? void 0 : notificationsObject.clickToActionButton;
    var notificationsList = notificationsObject === null || notificationsObject === void 0 ? void 0 : notificationsObject.notifications;
    var impressionAnalytics = notificationsObject === null || notificationsObject === void 0 ? void 0 : notificationsObject.impressionAnalytics;
    return /* @__PURE__ */ React10.createElement(NotificationsListProvider, {
        notificationsList: notificationsList || [],
        unseenCount: 0
    }, /* @__PURE__ */ React10.createElement(NotificationsUpdateProvider, {
        mutationFunction: __UpdateNotificationsInMenuMutation
    }, /* @__PURE__ */ React10.createElement(CommunicationCenterPreviewMenuContent, {
        heading: heading,
        emptyState: emptyState,
        clickToActionButton: clickToActionButton,
        impressionAnalytics: impressionAnalytics
    })));
};
CommunicationCenterPreviewMenuContentWithContext.displayName = "CommunicationCenterPreviewMenuContentWithContext";
// src/components/preview-menu/preview-menu-content-wrapper.tsx
var __CommunicationCenterPreviewQuery = gql9(_templateObject8(), EGDSStylizedText.fragment, NotificationsDeleteActionForm.fragment, CommunicationCenterEmptyState.fragment, NotificationsItem.fragment);
var CommunicationCenterPreviewMenuContentWrapper = function(props) {
    var context = useBexApi4().context;
    var analyticsTracker = useClickTracker5();
    var unseen = props.unseen, icon = props.icon, impressionAnalytics = props.impressionAnalytics, clickAnalytics = props.clickAnalytics;
    var referrerId = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId;
    var linkName = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName;
    var _React11_useState = _slicedToArray(React11.useState(false), 2), isOpen = _React11_useState[0], setOpen = _React11_useState[1];
    var unseenState = unseen && unseen !== null && unseen > 0;
    var _React11_useState1 = _slicedToArray(React11.useState(unseenState), 2), isUnSeen = _React11_useState1[0], setUnSeen = _React11_useState1[1];
    var _React11_useState2 = _slicedToArray(React11.useState(false), 1), menuClickHandlerState = _React11_useState2[0];
    var impressionReferrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId;
    var impressionLinkName = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || "";
    var _useLazyQuery = _slicedToArray(useLazyQuery(__CommunicationCenterPreviewQuery, {
        variables: {
            context: context,
            optionalContext: {
                dropdownView: true
            }
        },
        ssr: false
    }), 2), loadNotifications = _useLazyQuery[0], _useLazyQuery_ = _useLazyQuery[1], called = _useLazyQuery_.called, loading = _useLazyQuery_.loading, data = _useLazyQuery_.data, error = _useLazyQuery_.error;
    var onMenuTriggerClick = function() {
        setOpen(!isOpen);
        if (unseen < 4) {
            setUnSeen(false);
        }
        if (!called) {
            loadNotifications({
                context: context
            });
        }
        if (!isOpen && referrerId && linkName) {
            analyticsTracker(referrerId, linkName, void 0, []);
        }
    };
    return /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem4, {
        minWidth: "zero",
        grow: 0
    }, /* @__PURE__ */ React11.createElement(UitkMenu, {
        isOpen: isOpen,
        onTriggerClick: onMenuTriggerClick,
        disableBodyClickHandler: menuClickHandlerState
    }, /* @__PURE__ */ React11.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React11.createElement(UitkTertiaryButton2, {
        className: "uitk-button-only-icon global-navigation-nav-button",
        size: UitkButtonSize2.LARGE
    }, /* @__PURE__ */ React11.createElement(UitkLayoutPosition2, {
        display: "inline-block",
        type: "relative"
    }, /* @__PURE__ */ React11.createElement(UitkIcon3, {
        name: icon.id,
        size: UitkIconSize2.LARGE
    }), /* @__PURE__ */ React11.createElement(UitkLayoutPosition2, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, /* @__PURE__ */ React11.createElement(UitkLayoutPosition2, {
        cloneElement: true,
        position: {
            right: "zero",
            top: "zero"
        },
        type: "absolute"
    }, impressionReferrerId && /* @__PURE__ */ React11.createElement(IntersectionTracker4, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, isUnSeen && /* @__PURE__ */ React11.createElement(UitkFloatingDotNotificationBadge, {
        visible: true
    }))))))), /* @__PURE__ */ React11.createElement(UitkMenuContainer, {
        position: PositionType.RIGHT,
        autoPosition: true,
        width: 375,
        maxHeight: 576
    }, /* @__PURE__ */ React11.createElement("div", {
        style: {
            height: 576
        },
        role: "menu"
    }, (loading || error) && /* @__PURE__ */ React11.createElement(UitkLayoutFlex4, {
        justifyContent: "center",
        alignItems: "center",
        direction: "column",
        blockSize: "full_size"
    }, /* @__PURE__ */ React11.createElement(React11.Fragment, null, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React11.createElement(UitkLoader, null)))), !loading && !error && data && data.communicationCenterPreview && /* @__PURE__ */ React11.createElement(CommunicationCenterPreviewMenuContentWithContext, {
        data: data.communicationCenterPreview
    })))));
};
CommunicationCenterPreviewMenuContentWrapper.displayName = "CommunicationCenterPreviewMenuContentWrapper";
// src/components/preview-menu/preview-menu-link-content.tsx
import React12 from "react";
import { IntersectionTracker as IntersectionTracker5, useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkFloatingDotNotificationBadge as UitkFloatingDotNotificationBadge2 } from "uitk-react-badge";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var CommunicationCenterPreviewMenuLinkContent = function(props) {
    var analyticsTracker = useClickTracker6();
    var unseen = props.unseen, label = props.label, impressionAnalytics = props.impressionAnalytics, clickAnalytics = props.clickAnalytics;
    var referrerId = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.referrerId;
    var linkName = clickAnalytics === null || clickAnalytics === void 0 ? void 0 : clickAnalytics.linkName;
    var unseenState = unseen && unseen !== null && unseen > 0;
    var _React12_useState = _slicedToArray(React12.useState(unseenState), 2), isUnSeen = _React12_useState[0], setUnSeen = _React12_useState[1];
    var impressionReferrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId;
    var impressionLinkName = (impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) || "";
    var onMenuLinkClick = function() {
        setUnSeen(false);
        if (referrerId && linkName) {
            analyticsTracker(referrerId, linkName, void 0, []);
        }
    };
    return /* @__PURE__ */ React12.createElement("a", {
        href: "/inbox/notifications"
    }, /* @__PURE__ */ React12.createElement(React12.Fragment, null, /* @__PURE__ */ React12.createElement(UitkSpacing4, {
        padding: {
            block: "three",
            inline: "six"
        }
    }, /* @__PURE__ */ React12.createElement(UitkLink, {
        onClick: onMenuLinkClick
    }, /* @__PURE__ */ React12.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React12.createElement(UitkLayoutFlex5, null, /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React12.createElement(UitkText3, {
        size: 300,
        theme: "default"
    }, label)), /* @__PURE__ */ React12.createElement(UitkLayoutFlexItem5, null, impressionReferrerId && /* @__PURE__ */ React12.createElement(IntersectionTracker5, {
        referrerId: impressionReferrerId,
        linkName: impressionLinkName
    }, isUnSeen && /* @__PURE__ */ React12.createElement(UitkFloatingDotNotificationBadge2, {
        visible: true
    })))))))));
};
CommunicationCenterPreviewMenuLinkContent.displayName = "CommunicationCenterPreviewMenuLinkContent";
// src/components/preview-menu/preview-menu.tsx
var __Query = gql10(_templateObject9());
var __HeaderQuery = gql10(_templateObject10());
var CommunicationCenterPreviewMenu = function(props) {
    var _previewMenu_impressionAnalytics, _previewMenu_clickAnalytics;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var lineOfBusiness = inputs.lineOfBusiness, viewSize = inputs.viewSize;
    var context = useBexApi5().context;
    var client = useApolloClient();
    var onCompleted = function(data2) {
        var _data2_communicationCenterEntryPoint, _context_identity;
        var unseen = data2 === null || data2 === void 0 ? void 0 : (_data2_communicationCenterEntryPoint = data2.communicationCenterEntryPoint) === null || _data2_communicationCenterEntryPoint === void 0 ? void 0 : _data2_communicationCenterEntryPoint.notificationUnseenCount;
        if (unseen !== null && unseen > 0 && (context === null || context === void 0 ? void 0 : (_context_identity = context.identity) === null || _context_identity === void 0 ? void 0 : _context_identity.authState) === "AUTHENTICATED") {
            client.writeQuery({
                query: __HeaderQuery,
                data: {
                    globalHeader: {
                        redDotState: "VISIBLE" /* VISIBLE */ 
                    }
                },
                variables: {
                    context: context,
                    viewSize: viewSize,
                    lineOfBusiness: lineOfBusiness
                }
            });
        }
    };
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: skipSsr,
        onCompleted: onCompleted
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data) {
        return null;
    }
    var previewMenu = data === null || data === void 0 ? void 0 : data.communicationCenterEntryPoint;
    var label = previewMenu === null || previewMenu === void 0 ? void 0 : previewMenu.label;
    var icon = previewMenu === null || previewMenu === void 0 ? void 0 : previewMenu.icon;
    var notificationUnseenCount = previewMenu === null || previewMenu === void 0 ? void 0 : previewMenu.notificationUnseenCount;
    var impressionAnalytics = previewMenu === null || previewMenu === void 0 ? void 0 : (_previewMenu_impressionAnalytics = previewMenu.impressionAnalytics) === null || _previewMenu_impressionAnalytics === void 0 ? void 0 : _previewMenu_impressionAnalytics[0];
    var clickAnalytics = previewMenu === null || previewMenu === void 0 ? void 0 : (_previewMenu_clickAnalytics = previewMenu.clickAnalytics) === null || _previewMenu_clickAnalytics === void 0 ? void 0 : _previewMenu_clickAnalytics[0];
    return /* @__PURE__ */ React13.createElement(Viewport, null, /* @__PURE__ */ React13.createElement(ViewMedium, null, /* @__PURE__ */ React13.createElement(CommunicationCenterPreviewMenuContentWrapper, {
        unseen: notificationUnseenCount || 0,
        icon: icon,
        impressionAnalytics: impressionAnalytics,
        clickAnalytics: clickAnalytics
    })), /* @__PURE__ */ React13.createElement(ViewSmall, null, /* @__PURE__ */ React13.createElement(CommunicationCenterPreviewMenuLinkContent, {
        unseen: notificationUnseenCount || 0,
        label: label || "",
        impressionAnalytics: impressionAnalytics,
        clickAnalytics: clickAnalytics
    })));
};
CommunicationCenterPreviewMenu.displayName = "CommunicationCenterPreviewMenu";
export { CommunicationCenterPreviewMenu };
//# sourceMappingURL=index.js.map